export default __webpack_public_path__ + "static/media/contacts.183adf72.svg";